import { Component, Input, Output, EventEmitter, ElementRef, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { DropdownOption } from '../../interfaces/dropdown';

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss', './custom-dropdown.component.en.scss']
})
export class CustomDropdownComponent implements AfterViewInit {
  @Input() set options (value: DropdownOption[]) {
    this.dropdownOptions = value;
       value.forEach(option => {
     if(option.isSelected)
        this.selectedOption = option;
    });
  };
  @Input() placeholder: string = '';
  @Input() class: string = '';
  @Input() optionsContainerClass: string = '';
  @Input() optionsClass: string = '';
  @Input() selectedOptionClass: string = '';
  @Input() showSelectedOptionAndPlaceholder: boolean = false;

  @Output() valueSelected = new EventEmitter<any>();

  selectedOption: any | null = null;
  isDropdownOpen = false;
  dropdownOptions: DropdownOption[] = [];

  @ViewChild('dropdownList') dropdownList: ElementRef | undefined;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit() {
    if (this.dropdownOptions.length > 0 && !this.placeholder) {
      this.selectedOption = this.dropdownOptions[0];
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  onSelect(option: DropdownOption): void {
    this.selectedOption = option;
    this.isDropdownOpen = false;
    this.valueSelected.emit(this.selectedOption.value);
  }

  onDropdownKeyDown(event: KeyboardEvent): void {
    switch (event.key) {
      case 'Enter':
        this.toggleDropdown();
        if (!this.isDropdownOpen)
         this.valueSelected.emit(this.selectedOption.value);
        break;
      case 'Escape':
        this.isDropdownOpen = false;
        break;
      case 'ArrowDown':
        event.preventDefault();
        this.focusNextOption();
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.focusPreviousOption();
        break;
    }
  }

  focusNextOption(): void {
    const currentIndex = this.dropdownOptions.findIndex((option) => option.value === this.selectedOption?.value);
    const nextIndex = (currentIndex + 1) % this.dropdownOptions.length;
    this.selectedOption = this.dropdownOptions[nextIndex];
    this.scrollOptionIntoView(nextIndex);
  }

  focusPreviousOption(): void {
    const currentIndex = this.dropdownOptions.findIndex((option) => option.value === this.selectedOption?.value);
    const previousIndex = currentIndex === 0 ? this.dropdownOptions.length - 1 : currentIndex - 1;
    this.selectedOption = this.dropdownOptions[previousIndex];
    this.scrollOptionIntoView(previousIndex);
  }

  scrollOptionIntoView(index: number): void {
    if (this.dropdownList && this.dropdownList.nativeElement) {
      const list = this.dropdownList.nativeElement;
      const selectedOption = document.getElementById(this.dropdownOptions[index].value);
      if (list && selectedOption) {
        const listRect = list.getBoundingClientRect();
        const optionRect = selectedOption.getBoundingClientRect();
        if (optionRect.top < listRect.top) {
          list.scrollTop = selectedOption.offsetTop;
        } else if (optionRect.bottom > listRect.bottom) {
          list.scrollTop = selectedOption.offsetTop - listRect.height + optionRect.height;
        }
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }
}
